<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M17.8 11.44c-.68-.32-1.4-.44-2.2-.44H12v10h3.6c.72 0 1.4-.12 2.04-.4 1.48-.6 3.24-1.92 3.24-4.6.04-2.6-1.68-3.92-3.08-4.56z"/><path d="M17.8 11.44c-.68-.32-1.4-.44-2.2-.44H12v10h3.6c.72 0 1.4-.12 2.04-.4 1.48-.6 3.24-1.92 3.24-4.6.04-2.6-1.68-3.92-3.08-4.56z"/><path fill-rule="evenodd" d="M25.28 6.72H6.72v18.56h18.56V6.72zm-7.04 15.36c-.84.36-1.72.52-2.64.52h-5.24V9.4h5.24c1 0 1.96.2 2.84.6 2.6 1.16 4.04 3.32 4.04 6 0 3.76-2.64 5.4-4.24 6.08z" clip-rule="evenodd"/><path fill-rule="evenodd" d="M4.04 27.96V4.08h23.88v23.88H4.04zM5.8 26.2h20.4V5.8H5.8v20.4z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'brandDooca'
}
</script>
